import styled from 'styled-components/macro';
import Autocomplete from '@mui/material/Autocomplete';

const StyleAutoCompleteCheckBox = styled(Autocomplete)``;

export {StyleAutoCompleteCheckBox};
